import React from 'react';
import { observer } from 'mobx-react';
import { FormGroup, FormControl } from 'react-bootstrap';

export const CustomerDropdown = observer(({ customers, customerCode, setCustomerCode }) => {
  const onChange = (event) => {
    setCustomerCode(event.target.value);
  };

  return (
    <FormGroup controlId="customersSelect">
      <FormControl componentClass="select"
        value={customerCode}
        onChange={onChange}
      >
        <option value={0} key={0}>Select a customer</option>
        {customers.map(customer => <option value={customer.code} key={customer.id}>{customer.name}</option>)}
      </FormControl>
    </FormGroup>
  );
});
